import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import { PageSEO } from '../utils/seo';

export default function NotFound() {
  return (
    <>
      <PageSEO
        title="Pagina non trovata"
        description="La pagina che cerchi non esiste o è stata spostata."
        noindex
      />
      <Navbar />
      <main style={{
        background: 'var(--color-bg)', minHeight: '100vh',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        textAlign: 'center', padding: '6rem 1.75rem',
      }}>
        <div>
          <p style={{
            fontFamily: 'var(--font-mono)', fontSize: '0.78rem', letterSpacing: '0.12em',
            color: 'var(--color-accent-mid)', marginBottom: '1rem',
          }}>
            // 404
          </p>
          <h1 className="gradient-text" style={{
            fontSize: 'clamp(2.4rem, 6vw, 4rem)', fontWeight: 800, marginBottom: '1rem',
          }}>
            Pagina non trovata.
          </h1>
          <p style={{ color: 'var(--color-text-2)', maxWidth: '44ch', margin: '0 auto 2.5rem', lineHeight: 1.7 }}>
            L'indirizzo non esiste o è stato spostato.
          </p>
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" className="btn-primary">Torna alla home</Link>
            <Link to="/progetti" className="btn-secondary">Vedi i progetti</Link>
          </div>
        </div>
      </main>
    </>
  );
}
